import { motion } from "framer-motion";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import { useTranslation } from "@/i18n";
import { events } from "@/data/events";

export default function EventBanner() {
  const { t } = useTranslation();
  if (!events.length) return null;

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative border-y border-gold/15 bg-ink-soft/60"
      data-testid="event-banner"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 py-8 sm:py-10 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
        <div className="flex items-start gap-4 lg:max-w-xl">
          <span className="mt-1 w-9 h-9 border border-gold/30 flex items-center justify-center shrink-0">
            <CalendarDays className="w-4 h-4 text-gold" />
          </span>
          <div>
            <p className="label-accent" data-testid="event-label">{t("event.label")}</p>
            <p className="mt-2 font-serif text-lg sm:text-xl leading-snug text-[#FAF8F5]" data-testid="event-title">
              {t("event.title")}
            </p>
            <p className="mt-1.5 text-xs text-[#9BA1B0]">{t("event.note")}</p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 lg:ml-auto shrink-0">
          {events.map((e, i) => (
            <a
              key={e.url}
              href={e.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`event-link-${i}`}
              className="group flex items-center gap-4 border border-gold/25 hover:border-gold px-5 py-4 transition-colors duration-300 hover:bg-gold/5"
            >
              <div>
                <p className="font-mono text-sm text-gold">{e.date} · {e.time}</p>
                <p className="mt-0.5 text-xs text-[#9BA1B0]">{e.city}</p>
              </div>
              <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-gold whitespace-nowrap">
                {t("event.cta")}
                <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
